/* @flow */
// typecheck: ignore file
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import GroupActions from 'groups/actions/GroupActions';
import Group from 'entities/Group';
import React from 'react';
import ToastActions from 'actions/ToastActions';

type Props = {
  group: Group,
  onActionCompletion: Function,
  onRequestHide?: () => any,
};

export default class RemoveClassConfirmDialog extends React.Component {
  props: Props;

  onSuccess = (group: Group) => {
    ToastActions.showSuccessToast('Class archived');
    this.props.onActionCompletion(group);
  }

  onError = (error: Object) => {
    ToastActions.showErrorToast(error.message);
  }

  handleRemove = () => {
    const { group } = this.props;

    return GroupActions.archiveGroup(group).then(
      this.onSuccess,
      this.onError,
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="RemoveClassConfirmDialog"
        group={this.props.group}
        title="Remove this class from your list?"
        subtext={'This class will be archived, but you can always view and restore it from your settings.'}
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        onRequestHide={this.props.onRequestHide}
        preConfirmPromise={this.handleRemove}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/RemoveClassConfirmDialog.jsx